import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import axios from "axios";
import { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState("");
  // Validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is Required"),
    email: Yup.string()
      .required("Email is Required")
      .email("Entered value does not match email format"),
    message: Yup.string().required("Please, leave us a message."),
  });

  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  // Form functions
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors } = formState;

  // Form submission
  const onSubmit = (data, e) => {
    // Define the API endpoint
    const apiEndpoint = `users/newUser`;
    const apiUrl = process.env.REACT_APP_API_BASE_URL + apiEndpoint;

    // Display form data on success
    console.log("Message submitted:", data);

    // API call to submit the form data
    axios
      .post(apiUrl, data)
      .then((response) => {
        setFormData(response.data);
        console.log("API Response:", response.data);
        e.target.reset();
        // Handle success, e.g., show a success message to the user
      })
      .catch((error) => {
        setFormData(error.response?.data);
        console.error("API Error:", error.response?.data);
        // Handle error, e.g., show an error message to the user
      });

    // e.target.reset(); // Reset the form after submission
  };
  return (
    <Fragment>
      <form id="contact-form" action="#" onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12">
            {/* {formData?.status === 200 && (
              <h1
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "green",
                  marginBottom: "20px",
                }}
              >
                {formData.message}
              </h1>
            )} */}
            {formData &&
              (console.log("1111111"),
              (
                <h1
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "green",
                    marginBottom: "20px",
                  }}
                >
                  {formData.message}
                </h1>
              ))}

            <div className="input-group-meta form-group mb-30">
              <label>Name*</label>
              <input
                type="text"
                placeholder="Name"
                name="name"
                {...register("name")}
                className={`${errors.name ? "is-invalid" : ""}`}
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name?.message}</div>
              )}
            </div>
          </div>
          <div className="col-12">
            <div className="input-group-meta form-group mb-30">
              <label>Email*</label>
              <input
                type="text"
                placeholder="Email"
                name="email"
                {...register("email")}
                className={`${errors.email ? "is-invalid" : ""}`}
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email?.message}</div>
              )}
            </div>
          </div>
          <div className="col-12">
            <div className="input-group-meta form-group mb-30">
              <textarea
                placeholder="Your message*"
                name="message"
                {...register("message")}
                className={`${errors.message ? "is-invalid" : ""}`}
              />
              {errors.message && (
                <div className="invalid-feedback">
                  {errors.message?.message}
                </div>
              )}
            </div>
          </div>
          <div className="col-12">
            <button className="btn-eight ripple-btn" type="submit">
              Send Message
            </button>
          </div>
        </div>
      </form>
    </Fragment>
  );
};

export default ContactForm;
